exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin-bottom[data-v-2a407756] {\n  margin-bottom: 5px;\n}\n.date-picker-with-suggestions[data-v-2a407756] {\n  display: inline-block;\n  width: 100%;\n}\n", ""]);

// exports
